/* eslint-disable */
export default {
  title: '音訊',
  dialButtonVolume: '撥號按鈕音量',
  ringtoneVolume: '鈴聲音量',
  callVolume: '通話音量',
  muteCalls: '通話靜音',
  outputDevice: '輸出裝置',
  inputDevice: '輸入裝置',
  micPermission: '麥克風權限',
  noDevice: '無裝置',
  checkMicPermission: '檢查權限',
  micNoPermissionMessage: '應用程式沒有使用麥克風的權限',
  noLabel: '未知的裝置',
  notSetSinkIdTip:
    '抱歉，您目前的瀏覽器權限未設定為允許存取您的音訊輸出裝置。{clickHereLink}以檢視如何設定。',
  noLabelTip: '抱歉，您目前的瀏覽器權限未設為允許存取您的音訊輸入裝置。',
  clickHere: '按一下這裡',
  defaultOutputDevice: '預設輸出裝置',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"dialButtonVolume"@#@ @source: @#@"Dial Button Volume"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone Volume"@#@
// @key: @#@"callVolume"@#@ @source: @#@"Call Volume"@#@
// @key: @#@"muteCalls"@#@ @source: @#@"Mute Calls"@#@
// @key: @#@"outputDevice"@#@ @source: @#@"Output Device"@#@
// @key: @#@"inputDevice"@#@ @source: @#@"Input Device"@#@
// @key: @#@"micPermission"@#@ @source: @#@"Microphone Permission"@#@
// @key: @#@"noDevice"@#@ @source: @#@"No device"@#@
// @key: @#@"checkMicPermission"@#@ @source: @#@"Check Permission"@#@
// @key: @#@"micNoPermissionMessage"@#@ @source: @#@"The app does not have permission to use microphone"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"notSetSinkIdTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio output devices. {clickHereLink} to see how to set up."@#@
// @key: @#@"noLabelTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio input devices."@#@
// @key: @#@"clickHere"@#@ @source: @#@"Click here"@#@
// @key: @#@"defaultOutputDevice"@#@ @source: @#@"Default output device"@#@
